import {cloneDeep} from 'lodash';
import * as React from 'react';

import {IPostcardImage, IDocument, IUserData} from '../../../../infrastructure/interfaces';
import PostcardImageBackForm from '../../../DocumentEditor/PostcardImageBackEditorForm';
import SettingsNav from './SettingsNav';

export interface IPostcardImageBackProps {
  document: IDocument;
  postcardImages: IPostcardImage[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface IPostcardImageBackState {
  document: IDocument;
}


export default class PostcardImageBack extends React.Component<IPostcardImageBackProps, IPostcardImageBackState> {
  contentNode: Element;
  constructor(props: IPostcardImageBackProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.contentNode.parentElement!.scrollTop = 0;
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IPostcardImageBackProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onPostcardImageBackChange = (postcardImageBack: IPostcardImage) => {
    this.setState({
      document: {
        ...this.state.document,
        postcardImageBack,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Select the back postcard background image:
        </div>
        </div>
        <PostcardImageBackForm
          document={this.state.document}
          postcardImagesList={this.props.postcardImages}
          onPostcardImageChangeBack={this.onPostcardImageBackChange}
          className="settingsCropsListContainer"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/PostcardImageBackEditor.tsx